<!-- 
      *
      * Home for Regular User
      *
     -->
<ng-container *ngIf="role == 'regular-user' || role == 'company-administrator'">
  <regular-user-home></regular-user-home>
</ng-container>

<!-- 
      *
      * Home for Super Admin
      *
     -->

<ng-container *ngIf="role == 'super-admin'">
  <super-admin-home></super-admin-home>
</ng-container>

<!-- 
      *
      * Home for Company Manager
      *
     -->

<!-- <ng-container *ngIf="role == 'company-administrator'">
  <company-manager-home></company-manager-home>
</ng-container> -->
